import styled from 'styled-components';

import { Container, appearFromLeft } from '../styles';

export const FormSecondSectionWrapper = styled(Container)`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 42px;
  border-top: 1px solid #e4e9f0;

  animation: ${appearFromLeft} 1s;
`;

export const FormHeader = styled.div`
  display: flex;
  width: 65%;
  justify-content: space-between;
  margin-top: 36px;
  align-items: flex-end;
`;

export const TableWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 55px;
`;

export const TableGrid = styled.div`
  display: grid;
  grid-template-columns: 3.5fr 0.8fr 1.2fr 1fr 1.2fr 1.5fr 1.8fr 1fr;
`;

export const TableHeader = styled(TableGrid)`
  width: 100%;
  height: 50px;
  align-items: center;

  h4 {
    margin: 0;
    font-weight: 500;
    font-size: 12px;
    line-height: 13px;
    color: #98a2b3;
  }
`;

export const CourseInfo = styled.div`
  display: flex;
  padding: 0 18px;
  align-items: center;

  input {
    cursor: pointer;
  }

  label {
    margin: 0 0 0 18px;
    font-weight: 300;
    font-size: 12px;
    line-height: 13px;
    color: #7a8799;
    cursor: pointer;
  }

  span {
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
    line-height: 11px;
    color: #98a2b2;
    margin-left: 8px;
  }
`;

export const ButtonsFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 100px;
  margin-top: 20px;

  .btn-right-align {
    display: flex;
    justify-content: space-between;
    align-items: right;
  }
`;
